import TagNameComponentClass, {isTagNameComponentClass} from "./TagNameComponentClass";

export default interface NamespaceUriComponentClass<CE extends Element, T> extends TagNameComponentClass<CE, T> {
	componentNamespaceUri: string;
}

export function isNamespaceUriComponentClass<CE extends Element>(clazz: any): clazz is NamespaceUriComponentClass<CE, any> {
	return typeof clazz?.componentNamespaceUri === "string" && isTagNameComponentClass(clazz);
}
